import styled from 'styled-components';

export const Container = styled.div`
  background-color: #d4d8db;
  padding: 16px;

  .scale-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 16px;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }
  }

  .label {
    font-style: italic;
    color: #6c757d;
    font-size: 14px;

    @media (max-width: 768px) {
      margin-bottom: 8px;
    }
  }

  .buttons-wrapper {
    display: flex;
    gap: 8px;
    justify-content: center;
    flex-wrap: wrap;
  }

  .btn-outline-primary {
    border-radius: 50px;
    background-color: ${(props) => props.theme.$white};
    border-color: #8c95a4;
    color: #212529;
    font-size: 16px;
    padding: 8px 16px;
    transition: background-color 0.3s ease;

    &:hover,
    &:active,
    &.current {
      background-color: #368e7a;
      color: #ffffff;
      border-color: #368e7a;
    }

    @media (max-width: 768px) {
      font-size: 12px;
      padding: 6px 12px;
      margin: 0;
    }
  }

  span {
    color: #212529;
  }

  .btn-input-send {
    background: ${(props) => props.theme.$primary_green};
    color: ${(props) => props.theme.$white};
    border-radius: 0 4px 4px 0;
    &:disabled {
      cursor: default;
    }
  }

  .notes-input-group {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
  }

  .feedback-textarea {
    width: 100%;
    resize: none;
    min-height: 40px;
    line-height: 1.5;
    padding: 10px;
    box-sizing: border-box;
    overflow: hidden;
  }

  .btn-input-send {
    flex-shrink: 0;
    background-color: #368e7a;
    color: #ffffff;
    height: 40px;
    padding: 0 15px;
    border-radius: 5px;
  }
`;
